import dayjs from 'dayjs';
import { Talhao, TalhaoRow } from '../../../../@types';

export const getDataEstimadaParaAplicar = ({
  dataBase,
  areaAplicada,
  rendimentoOperacional,
}: {
  dataBase: Date;
  areaAplicada: number;
  rendimentoOperacional: number;
}) =>
  dayjs(dataBase)
    .add(areaAplicada / rendimentoOperacional, 'days')
    .toDate();

export const getAreaDisponivel = (talhoes: TalhaoRow[], talhao: Talhao) => {
  const areaSelecionada = talhoes
    .filter((row) => row.talhao?.id === talhao.id)
    .reduce((soma, current) => soma + (current.area || 0), 0);

  return Math.max(talhao.areaTotal - areaSelecionada, 0);
};
